const LAST_CREATED_COMPANY_KEY = 'cso_last_created_company_id';

/** Remember the most recently added company for pre-select in mapping forms. */
export function setLastCreatedCompanyId(companyId) {
  if (companyId != null && companyId !== '') {
    sessionStorage.setItem(LAST_CREATED_COMPANY_KEY, String(companyId));
  }
}

/** Prefer last-added company when it still exists in the list; otherwise no default. */
export function getPreferredCompanyId(companies) {
  const preferred = sessionStorage.getItem(LAST_CREATED_COMPANY_KEY);
  if (preferred && (companies || []).some((c) => String(c.id) === preferred)) {
    return preferred;
  }
  return '';
}
